@if (photos) {
  <div [ngClass]="{ 'gallery-bottom': photos && quote }">
    <mat-expansion-panel
      (closed)="galleryCurtainOpened = false"
      (opened)="galleryCurtainOpened = true"
      class="curtains"
      #panel>
      <mat-expansion-panel-header [collapsedHeight]="'100px'" [expandedHeight]="'100px'">
        <mat-panel-title [ngClass]="{ 'opened-gallery': galleryCurtainOpened }" class="gallery-title">
          <h6>{{ photos.length }} {{ photos.length === 1 ? 'Photo' : 'Photos' }}</h6>
        </mat-panel-title>
        <mat-panel-description [ngClass]="{ 'closed-gallery': !galleryCurtainOpened }">
          <div class="gallery-container">
            @if (!galleryCurtainOpened) {
              <!--this ngForOF syntax used by the ng-template directive-->
              <div class="gallery-row">
                @for (photo of photos; track photo; let i = $index) {
                  <div class="image-box">
                    @if (photo.thumbNailUrl) {
                      <img
                        [hidden]="!photoLoaded[i]"
                        (click)="$event.stopPropagation(); openLightbox(i)"
                        [src]="photo.thumbNailUrl"
                        (error)="photoLoaded[i] = false"
                        (load)="photoLoaded[i] = true" />
                    }
                    @if (photo.submitted && currentUser.privileges.includes('SYSADMIN') && !photo.addedInV6) {
                      <mat-icon
                        class="delete"
                        (click)="confirmDeletePhoto(photo.id, job.jobId); $event.stopPropagation()"
                        >delete_forever</mat-icon
                      >
                    }
                    <mat-icon
                      class="star"
                      [class.unselectedPhoto]="!photo.topImage"
                      (click)="!photo.topImage && selectPhoto(photo); $event.stopPropagation()"
                      >{{ photo.topImage ? 'star' : 'star_border' }}</mat-icon
                    >
                    @if (!photoLoaded[i]) {
                      <div class="spinner-box" [class.spinner]="!photoLoaded[i]">
                        <mat-spinner [diameter]="44"></mat-spinner>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        </mat-panel-description>
        <mat-panel-description class="kebab-panel">
          @if (photos.length && !photos[0].submitted) {
            <div class="secondary-icon">
              <button matIconButton (click)="$event.stopPropagation(); confirmDeleteUnsubmittedphotos()">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          }
        </mat-panel-description>
      </mat-expansion-panel-header>
      <mat-divider></mat-divider>
      <div class="gallery-container">
        @if (galleryCurtainOpened) {
          @for (photo of photos; track photo; let i = $index) {
            <div class="image-box">
              @if (photo?.thumbNailUrl) {
                <img
                  [hidden]="!photoLoaded[i]"
                  (click)="$event.stopPropagation(); openLightbox(i)"
                  [src]="photo.thumbNailUrl"
                  (error)="photoLoaded[i] = false"
                  (load)="photoLoaded[i] = true" />
              }
              @if (!photoLoaded[i]) {
                <div class="spinner-box" [class.spinner]="!photoLoaded[i]">
                  <mat-spinner [diameter]="44"></mat-spinner>
                </div>
              }
              @if (
                !photo.submitted || (photo.submitted && currentUser.privileges.includes('SYSADMIN') && !photo.addedInV6)
              ) {
                <mat-icon class="delete" (click)="confirmDeletePhoto(photo.id, job.jobId)">delete_forever</mat-icon>
              }
              <mat-icon
                class="star"
                [class.unselectedPhoto]="!photo.topImage"
                (click)="!photo.topImage && selectPhoto(photo)"
                >{{ photo.topImage ? 'star' : 'star_border' }}</mat-icon
              >
            </div>
          }
        }
      </div>
    </mat-expansion-panel>
  </div>
}
